import { useNavigate, useParams } from 'react-router-dom';
import VinModificationLayout from './VinModificationLayout';

type Params = {
  id: string;
};

const VinModicationPage = (): JSX.Element => {
  const history = useNavigate();
  const { id } = useParams<Params>();

  function goToDashboard(): void {
    history('/');
  }

  return (
    <VinModificationLayout
      quotationHash={id as string}
      onClose={goToDashboard}
      data-testid="vin-layout"
    />
  );
};

export default VinModicationPage;
